import styled from "styled-components";

export const Container = styled.div`
  width: 96%;
  height: 2.68rem;
  display: flex;
  background-color: #585e66;
  margin-top: 3rem;

  box-shadow: 0px 5.62941px 11.2588px rgba(88, 94, 102, 0.08);
  border-radius: 4.22206px;

  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.74rem;
  line-height: 0.95rem;

  color: #eff1f5;
`;

export const HeaderTable0 = styled.span`
  width: 6.8%;
`;
export const HeaderTable1 = styled.span`
  width: 22.27%;
  margin-top: 0.87rem;
`;
export const HeaderTable2 = styled.span`
  width: 33.36%;
  margin-top: 0.87rem;
`;
export const HeaderTable3 = styled.span`
  width: 16.81%;
  margin-top: 0.87rem;
`;
export const HeaderTable4 = styled.span`
  width: 15.18%;
  margin-top: 0.87rem;
`;
export const HeaderTable5 = styled.span`
  width: 5.58%;
  margin-top: 0.87rem;
`;
